// extracted by mini-css-extract-plugin
export default {"root":"EditListingSocialsPanel_root__MPySL","form":"EditListingSocialsPanel_form__EwbZ8","title":"EditListingSocialsPanel_title__ghNFo"};